import { useContext, createContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CircleLeftArrow from "../../Components/Icons/CircleLeftArrow";
import CircleRightArrow from "../../Components/Icons/CircleRightArrow";
import { useTranslation } from "react-i18next";
import Settings from "../../Components/Icons/Settings";
import { GetAccess, GetMultipleAccess } from "../../Components/Utils/roles";
import { Tooltip } from "antd";
import sidelogo from "../../assets/images/logoname.png";
import logo from "../../assets/images/logoo.png";

const SidebarContext = createContext();

const Submenu = ({ subItems }) => {
  const { t, i18n } = useTranslation();

  const [topPosition, setTopPosition] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const screenHeight = window.innerHeight;
    const submenuHeight = subItems.length * 75; // Adjust this value based on the actual submenu item height
    if (screenHeight < submenuHeight) {
      console.log(screenHeight - submenuHeight);
      setTopPosition(screenHeight - submenuHeight);
    }
    setIsVisible(true);
  }, [subItems]);

  return (
    <div
      style={{ top: `${topPosition}px` }}
      //  className={`absolute rounded-md border border-[#3369ff] border-solid border-opacity-20 overflow-hidden left-full bg-[#E6F2F2] w-48 shadow-lg p-2 ${isVisible ? 'transition-opacity duration-1000 opacity-100' : 'opacity-0'} ease-in-out`}
      className={`
    absolute left-full  rounded-md px-1 ml-1
    bg-indigo-100 text-indigo-800  text-left
    invisible opacity-20 -translate-x-3 transition-all
    group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 w-52 text-sm
`}
    >
      {subItems.map((subItem, subIndex) => (
        <>
          {GetAccess(subItem?.hasAccess || "") && (
            <Link
              key={subIndex}
              to={`${subItem.link}`}
              className="flex justify-start my-1 rounded-md px-3 py-[3px] xl:py-2 bg-[#E6F2F2] text-gray-800 hover:bg-textColor-main hover:text-[#E6F2F2]"
            >
              {/* <i className={`fas fa-${subItem.icon} text-lg mr-2`}></i> */}
              <p
                className={` text-[11px] 2xl:text-sm text-left ${
                  i18n.language == "ar" ? "text-right" : "text-left"
                }`}
              >
                {t(subItem.name)}
              </p>
            </Link>
          )}
        </>
      ))}
    </div>
  );
};

export default function Sidebar({ children }) {
  const [expanded, setExpanded] = useState(false);
  const { t, i18n } = useTranslation();
  const branchId = localStorage.getItem("branchId")?JSON.parse(localStorage.getItem("branchId")):1;

  function getExpand() {
    let locExp = localStorage.getItem("expand");
    if (locExp) {
      setExpanded(JSON.parse(locExp));
    } else {
      localStorage.setItem("expand", true);
      setExpanded(true);
    }
  }

  useEffect(() => {
    // getExpand();
  }, []);

  function toggleExpanded(e) {
    setExpanded(e);
    localStorage.setItem("expand", e);
  }

  return (
    <aside className={`h-screen bg-white transition-all duration-300 ${
      expanded ? "w-60" : "w-16"
    } fixed left-0 top-0 `}
    onMouseEnter={() => setExpanded(true)}
    onMouseLeave={() => setExpanded(false)}
    >
      <nav className="h-full flex flex-col bg-white border-r shadow-sm">
     
<div className="p-4 pb-2 grid grid-cols-8 gap-2">
  <Link to="/dashboard" className="w-10 h-10  mr-1 flex justify-center items-center cursor-pointer">
             <img src={logo} alt="logo" className="object-contain" />

  </Link>

  <Link
    to="/dashboard"
    className={`overflow-hidden col-span-7 font-medium text-xl text-baseColor-primary transition-all cursor-pointer ${
      expanded ? "w-24 ml-4 mt-2" : "w-0"
    }`}
  >
                 <img src={sidelogo} alt="logo" className="object-contain" />

  </Link>
</div>

        <div className=" w-full h-[calc(100vh-120px)] ">
          <SidebarContext.Provider value={{ expanded }}>
            <ul
              className="flex-1 px-3"
              dir={i18n.language == "ar" ? "rtl" : ""}
            >
              {children}
            </ul>
          </SidebarContext.Provider>
        </div>

        {GetMultipleAccess([
          "settings_view",
          "companyinfo_view",
          "clientmanagement_view",
          "inspection_view",
          "commisioning_view",
          "refilling_view",
          "tickets_view",
          "invoice_view",
          "task_view",
          "contact_view",
          "equipment_view",
          "inspector_view",
          "roles_view",
          "user_view",
          "notification_view",
          "reference_view",
          "approvalpermission_view",
          "emailserver_view",
          "emailtemplates_view",
          "enable_disable_view",
          "surForm_view",
          "Form_Survey_view"

         
        ]) && (
          <div className="border-t flex p-3">
            <Link className="flex justify-between items-center" to={
              GetAccess("companyinfo_view")?`/settings`:
              GetAccess("clientmanagement_view")?`/settings/client-management`:
              GetAccess("inspection_view")?`/settings/inspection`:
              GetAccess("commisioning_view")?`/settings/commisioning`:
              GetAccess("refilling_view")?`/settings/refilling`:
              GetAccess("tickets_view")?`/settings/tickets`:
              GetAccess("invoice_view")?`/settings/invoice`:
              GetAccess("task_view")?`/settings/task`:
              GetAccess("contact_view")?`/settings/contacts`:
              GetAccess("equipment_view")?`/settings/equiments`:
              GetAccess("inspector_view")?`/settings/inspector`:
              GetAccess("roles_view")?`/settings/role`:
              GetAccess("user_view")?`/settings/user`:
              GetAccess("notification_view")?`/settings/notifications`:
              GetAccess("reference_view")?`/settings/reffrence`:
              GetAccess("approvalpermission_view")?`/settings/newApproval`:
              GetAccess("surForm_view")?`/settings/surForm`:
              GetAccess("emailserver_view")?`/settings/emailserverdetails`:
              GetAccess("emailtemplates_view")?`/settings/emailtemplate`:
              GetAccess("enable_disable_view")?`/settings/enableDisable`:
              GetAccess("dropDowns_view")?`/settings/dropDowns`:
              GetAccess("user_role_view")?`/settings/user-role`:
              GetAccess("job_role_view")?`/settings/job-role`:
              GetAccess("statuspermission_view")?`/settings/statuspermission`:
              GetAccess("sealandsignature_view")?`/settings/sealandsignature`:
              GetAccess("currency_vat_view")?`/settings/currency-vat`:
                            GetAccess("Form_Survey_view")?`/settings/formsApprove/survey`:

              GetAccess("newApproval_view")?`/settings/newApproval`:
              `/settings`
            }>
              <div className="p-2 bg-red-100 rounded-lg">
                <Settings color="#b91c1c" height={18} width={18} />
              </div>
            </Link>
            <Link className="flex justify-between items-center" to={
                            GetAccess("companyinfo_view")?`/settings`:
                            GetAccess("clientmanagement_view")?`/settings/client-management`:
                            GetAccess("inspection_view")?`/settings/inspection`:
                            GetAccess("commisioning_view")?`/settings/commisioning`:
                            GetAccess("refilling_view")?`/settings/refilling`:
                            GetAccess("tickets_view")?`/settings/tickets`:
                            GetAccess("invoice_view")?`/settings/invoice`:
                            GetAccess("task_view")?`/settings/task`:
                            GetAccess("contact_view")?`/settings/contacts`:
                            GetAccess("equipment_view")?`/settings/equiments`:
                            GetAccess("inspector_view")?`/settings/inspector`:
                            GetAccess("roles_view")?`/settings/role`:
                            GetAccess("user_view")?`/settings/user`:
                            GetAccess("notification_view")?`/settings/notifications`:
                            GetAccess("reference_view")?`/settings/reffrence`:
                            GetAccess("approvalpermission_view")?`/settings/newApproval`:
              GetAccess("surForm_view")?`/settings/surForm`:

                            GetAccess("emailserver_view")?`/settings/emailserverdetails`:
                            GetAccess("emailtemplates_view")?`/settings/emailtemplate`:
                            GetAccess("enable_disable_view")?`/settings/enableDisable`:
                            GetAccess("dropDowns_view")?`/settings/dropDowns`:
                            GetAccess("user_role_view")?`/settings/user-role`:
                            GetAccess("job_role_view")?`/settings/job-role`:
                            GetAccess("statuspermission_view")?`/settings/statuspermission`:
                            GetAccess("sealandsignature_view")?`/settings/sealandsignature`:
                            GetAccess("Form_Survey_view")?`/settings/formsApprove/survey`:

                            GetAccess("currency_vat_view")?`/settings/currency-vat`:
                            GetAccess("newApproval_view")?`/settings/newApproval`:
                            `/settings`
            }>
              <div
                className={`
              flex justify-between items-center
               overflow-hidden transition-all ${
                 expanded ? "w-28 xl:w-32 ml-3" : "w-0"
               }
          `}
              >
                <div className="leading-4">
                  <h4 className="font-semibold  text-xs 2xl:text-sm">
                    Settings
                  </h4>
                </div>
              </div>
            </Link>
          </div>
        )}

        <div className=" w-full px-2">
          <p className={`font-normal text-left text-[9px] text-slate-400`}>
            <a href="https://numota.in" target="_blank">
             &#169; numota
            </a>
          </p>
        </div>
        {/* </div> */}
      </nav>
    </aside>
  );
}

export function SidebarItem({
  icon,
  text,
  active,
  alert,
  hasSubMenu,
  subItem,
  link,
}) {
  const { expanded } = useContext(SidebarContext);
  const { t, i18n } = useTranslation();

  return (
    <>
      {!hasSubMenu ? (
        <Link to={link} className="">
          <li
            className={`
        relative flex items-center py-1 xl:py-2 px-3 my-1
        font-medium rounded-md cursor-pointer
        transition-colors group whitespace-nowrap
        ${
          active == true
            ? "bg-gradient-to-tr from-red-200 to-red-100 text-red-800"
            : "hover:bg-red-50 text-gray-600"
        }
    `}
          >
            <div className=" w-4  justify-center items-center  text-xs 2xl:text-sm">
              {
                expanded?<>{icon}</>:<Tooltip title={<p className=" text-[11px] text-white">{text||"-"}</p>} color="#999999 "><div>{icon}</div></Tooltip>
              }
            
            </div>

            <div
              className={`overflow-hidden  text-xs  ${
                expanded
                  ? `w-64 ${i18n.language == "ar" ? "mr-3" : "ml-3"} `
                  : "w-0"
              }`}
            >
              {
                expanded && <Link to={link} className="whitespace-nowrap">{text}</Link>
              }
              
            </div>
          </li>
        </Link>
      ) : (
        <li
          className={`
      relative flex items-center py-1 xl:py-2 px-3 my-1
      font-medium rounded-md cursor-pointer
      transition-colors group whitespace-nowrap
      ${
        active == true
          ? "bg-gradient-to-tr from-red-200 to-red-100 text-red-800"
          : "hover:bg-red-50 text-gray-600"
      }
  `}
        >
          <div className=" w-4 flex justify-center items-center  text-xs 2xl:text-sm">
            {icon}
          </div>

          <div
            className={`overflow-hidden transition-all text-xs 2xl:text-sm whitespace-nowrap ${
              expanded
                ? `w-28 xl:w-32 ${i18n.language == "ar" ? "mr-3" : "ml-3"} `
                : "w-0"
            }`}
          >
            {text}
          </div>
          <Submenu subItems={subItem || []} />
        </li>
      )}
    </>
  );
}
